import { useMemo } from 'react';
import { DropListComposedProps, DropListOption } from '../DropList';

interface UseDropListEmptyValueOptions<Value, OptionValue> {
  options: DropListComposedProps<Value, OptionValue>['options'];
  emptyValue: DropListComposedProps<Value, OptionValue>['emptyValue'];
  noEmptyValue: DropListComposedProps<Value, OptionValue>['noEmptyValue'];
  emptyLabel: DropListComposedProps<Value, OptionValue>['emptyLabel'];
  required: DropListComposedProps<Value, OptionValue>['required'];
}

const useDropListEmptyValue = <Value, OptionValue>({ options, emptyValue, noEmptyValue, emptyLabel, required }: UseDropListEmptyValueOptions<Value, OptionValue>) => {
  const emptyOption = useMemo(() => (
    options.find(({ value: optionsValue = emptyValue }) => optionsValue === emptyValue)
  ), [emptyValue, options]);

  const resolvedEmptyLabel = useMemo(() => (
    emptyOption?.label || emptyLabel
  ), [emptyOption, emptyLabel]);

  const optionsWithEmpty = useMemo(() => (
    (emptyOption || required || noEmptyValue) ?
      options :
      [
        {
          value: emptyValue,
          label: resolvedEmptyLabel,
        },
        ...options,
      ] as DropListOption<OptionValue>[]
  ), [emptyOption, required, noEmptyValue, options, emptyValue, resolvedEmptyLabel]);

  return {
    optionsWithEmpty,
    resolvedEmptyLabel,
  };
};

export default useDropListEmptyValue;
